import { Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

const FormLayout: FunctionComponent = ({ children }) => (
  <Flex sx={{ flexDirection: 'column', gap: 'xxl', width: '100%' }}>
    {children}
  </Flex>
);

export default FormLayout;
